"use client";

import { use } from "react";

import { TVSeriesPagePreloadContext } from "./tv-series-page-preload-context";

export const useTVSeriesPagePreloadData = () => {
  return use(TVSeriesPagePreloadContext);
};
